var validators = {
    validateEmails(emails) {
        const email_reg =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let is_valid = true;

        _.forEach(emails, function (email) {
            if (!email_reg.test(String(email).toLowerCase())) {
                is_valid = false;
            }
        });

        return is_valid;
    },
};

export default validators;
